const $ = require('jquery');

module.exports = function (moveFocus) {
    return {
        restrict: 'A',
        scope: false,
        link: {
            post(scope, element) {
                const selectedClass = 'active';
                const tabsAttributeSelector = 'oly-tab';
                const focusableClass = '._tabs-content-focusable';

                const hiddenClass = 'u-transparent u-displayNone';

                const tabHeaders = element.find(`[data-${tabsAttributeSelector}]`);
                const tabContents = [];

                // functions

                function hideAllTabContents() {
                    let tab;
                    for (let i = 0; i < tabContents.length; i++) {
                        tab = tabContents[i];
                        tab.addClass(hiddenClass).removeClass(selectedClass);
                    }
                    tabHeaders.removeClass(selectedClass);
                }

                (function init() {
                    // get all tab contents
                    for (let i = 0; i < tabHeaders.length; i++) {
                        tabContents.push(element.find(`#${$(tabHeaders[i]).attr(`data-${tabsAttributeSelector}`)}`).addClass('tab-content u-noOutline').attr('tabIndex', '-1'));
                    }

                    hideAllTabContents();

                    // display first tab
                    if (tabHeaders.length > 0) {
                        $(tabHeaders[0]).addClass(selectedClass).data(tabsAttributeSelector);
                        tabContents[0].removeClass(hiddenClass).addClass(selectedClass);
                    } else {
                        // if no tabs available: hide headers
                        tabHeaders.hide();
                    }
                })();

                // events

                tabHeaders.on('click', function () {
                    hideAllTabContents();
                    const selectedTabContent = element.find(`#${$(this).addClass(selectedClass).data(tabsAttributeSelector)}`);
                    selectedTabContent.removeClass(hiddenClass).addClass(selectedClass);
                    if (selectedTabContent.find(focusableClass).length > 0) {
                        moveFocus(selectedTabContent.find(focusableClass));
                    } else {
                        moveFocus(selectedTabContent);
                    }
                });
            }
        }
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/tabs/tabs-directive.js
 **/